
export default {
  name: 'rzButtonWithIcon',
  props: {
    borderRounded: Boolean,
    menu: Boolean,
    active: Boolean,
    disabled: Boolean,
  },
  computed: {
    classes() {
      return {
        'button-with-icon--border-rounded': this.borderRounded,
        'button-with-icon--menu': this.menu,
        'button-with-icon--active': this.active,
        'button-with-icon--disabled': this.disabled,
      };
    },
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    },
  },
};
